<ul class="sidebar">
  <a *ngIf="role === 'Administrador' || claims.includes('D_TINI')" [routerLink]="['home']">
    <li routerLinkActive="active" (click)="changeDropdown('')">
      <i class="fas fa-home"></i>
      <label>{{'sidebar.inicio' | translate}}</label>
    </li>
  </a>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TDSB')"
    [ngClass]="{'current': dropdown === 'dashboards', 'active': url.includes('dashboards')}"
    (click)=" changeDropdown('dashboards')">
    <i class="fas fa-map-marked"></i>
    <label>{{'sidebar.dashboards.des' | translate}}
      <i
        [ngClass]="dropdown === 'dashboards' || url.includes('dashboards') ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'dashboards' || url.includes('dashboards')">
    <a *ngIf="role === 'Administrador' || claims.includes('D_DEQ')" [routerLink]="['dashboards/etiquetadores']">
      <li routerLinkActive="active">
        <i>{{'sidebar.dashboards.etiquetadores.id' | translate}}</i>
        <label>{{'sidebar.dashboards.etiquetadores.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_DCV')" [routerLink]="['dashboards/cultivos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.dashboards.cultivos.id' | translate}}</i>
        <label>{{'sidebar.dashboards.cultivos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_DDS')" [routerLink]="['dashboards/designaciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.dashboards.designaciones.id' | translate}}</i>
        <label>{{'sidebar.dashboards.designaciones.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('DSH_Royalty')" [routerLink]="['dashboards/royalties']">
      <li routerLinkActive="active">
        <i>{{'sidebar.dashboards.royalties.id' | translate}}</i>
        <label>{{'sidebar.dashboards.royalties.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TDAT')"
    [ngClass]="{'current': dropdown === 'data', 'active': url.includes('data')}" (click)=" changeDropdown('data')">
    <i class="fa-solid fa-chart-line"></i>
    <label>{{'sidebar.data.des' | translate}}
      <i [ngClass]="dropdown === 'data' || url.includes('data') ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'data' || url.includes('data')">
    <a *ngIf="role === 'Administrador' || claims.includes('D_CAV')" [routerLink]="['data/central-avisos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.data.centralAvisos.id' | translate}}</i>
        <label>{{'sidebar.data.centralAvisos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CES')" [routerLink]="['data/central-estadisticas']">
      <li routerLinkActive="active">
        <i>{{'sidebar.data.centralEstadisticas.id' | translate}}</i>
        <label>{{'sidebar.data.centralEstadisticas.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TGV')"
    [ngClass]="{'current': dropdown === 'gestion', 'active': url.includes('gestion')}"
    (click)="changeDropdown('gestion')">
    <i class="fas fa-leaf"></i>
    <label>{{'sidebar.gestionVarietal.des' | translate}}
      <i [ngClass]="dropdown === 'gestion' || url.includes('gestion') ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'gestion' || url.includes('gestion/')">
    <a *ngIf="role === 'Administrador' || claims.includes('D_PRD')" [routerLink]="['gestion/mantenimiento-productos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.gestionVarietal.mantenimientoProductos.id' | translate}}</i>
        <label>{{'sidebar.gestionVarietal.mantenimientoProductos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_DNM')" [routerLink]="['gestion/mantenimiento-denominaciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.gestionVarietal.mantenimientoDenominaciones.id' | translate}}</i>
        <label>{{'sidebar.gestionVarietal.mantenimientoDenominaciones.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_MRC')" [routerLink]="['gestion/mantenimiento-marcas']">
      <li routerLinkActive="active">
        <i>{{'sidebar.gestionVarietal.mantenimientoMarcas.id' | translate}}</i>
        <label>{{'sidebar.gestionVarietal.mantenimientoMarcas.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CMP')" [routerLink]="['gestion/mantenimiento-campanyas']">
      <li routerLinkActive="active">
        <i>{{'sidebar.gestionVarietal.mantenimientoCampanyas.id' | translate}}</i>
        <label>{{'sidebar.gestionVarietal.mantenimientoCampanyas.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TCUL')"
    [ngClass]="{'current': dropdown === 'cultivos', 'active': url.includes('cultivos/')}"
    (click)="changeDropdown('cultivos')">
    <i class="fas fa-seedling"></i>
    <label>{{'sidebar.cultivos.des' | translate}}
      <i [ngClass]="dropdown === 'cultivos' || url.includes('cultivos/') ? 'fas fa-angle-up' : 'fas fa-angle-down'">
      </i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'cultivos' || url.includes('cultivos/')">
    <a *ngIf="role === 'Administrador' || claims.includes('D_MCV')" [routerLink]="['cultivos/mantenimiento-cultivos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.cultivos.mantenimientoCultivos.id' | translate}}</i>
        <label>{{'sidebar.cultivos.mantenimientoCultivos.des' | translate}}
        </label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_PRO')" [routerLink]="['cultivos/productores']">
      <li routerLinkActive="active">
        <i>{{'sidebar.usuarios.productores.id' | translate}}</i>
        <label>{{'sidebar.usuarios.productores.des' | translate}}
        </label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_EDP')" [routerLink]="['cultivos/edicion-poligonos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.cultivos.edicionPoligonos.id' | translate}}</i>
        <label>{{'sidebar.cultivos.edicionPoligonos.des' | translate}}
        </label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TETQ')"
    [ngClass]="{'current': dropdown === 'labeled', 'active': (url.includes('etiquetado/'))}"
    (click)="changeDropdown('labeled')">
    <i class="fas fa-tag"></i>
    <label>{{'sidebar.etiquetado.des' | translate}}
      <i
        [ngClass]="dropdown === 'labeled' || (url.includes('etiquetado/')) ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'labeled' || (url.includes('etiquetado/'))">
    <a *ngIf="role === 'Administrador' || claims.includes('D_MEV')" [routerLink]="['etiquetado/mantenimiento-envases']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.mantenimientoEnvases.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.mantenimientoEnvases.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_MCF')" [routerLink]="['etiquetado/mantenimiento-confecciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.mantenimientoConfecciones.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.mantenimientoConfecciones.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_DCF')" [routerLink]="['etiquetado/confecciones-duplicar']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.confeccionesDuplicar.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.confeccionesDuplicar.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_DSG')" [routerLink]="['etiquetado/mantenimiento-designaciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.designaciones.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.designaciones.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CNS')" [routerLink]="['etiquetado/consumos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.consumos.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.consumos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_ETQ')" [routerLink]="['etiquetado/etiquetado']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.etiquetado.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.etiquetado.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_RTQ')" [routerLink]="['etiquetado/reetiquetado']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.reetiquetado.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.reetiquetado.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_TOT')" [routerLink]="['etiquetado/totales']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.totales.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.totales.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_INC')" [routerLink]="['etiquetado/mantenimiento-incidencias']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.incidencias.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.incidencias.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_ETD')" [routerLink]="['etiquetado/mantenimiento-etiquetadores']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.mantenimientoEtiquetadores.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.mantenimientoEtiquetadores.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_ICV')" [routerLink]="['etiquetado/informe-cultivos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.informeCultivos.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.informeCultivos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_TRZ')" [routerLink]="['etiquetado/trazabilidad-etiqueta']">
      <li routerLinkActive="active">
        <i>{{'sidebar.etiquetado.trazabilidad.id' | translate}}</i>
        <label>{{'sidebar.etiquetado.trazabilidad.des' | translate}}</label>
      </li>
    </a>
  </ul>

  <li *ngIf="role === 'Administrador' || claims.includes('D_TEXP')"
    [ngClass]="{'current': dropdown === 'expediciones', 'active': (url.includes('expediciones/'))}"
    (click)="changeDropdown('expediciones')">
    <i class="fas fa-truck"></i>
    <label>{{'sidebar.expediciones.des' | translate}}
      <i
        [ngClass]="dropdown === 'expediciones' || (url.includes('expediciones/')) ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'expediciones' || (url.includes('expediciones/'))">
    <a *ngIf="role === 'Administrador' || claims.includes('D_EXP')" [routerLink]="['expediciones/mantenimiento-expediciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.expediciones.mantenimientoExpediciones.id' | translate}}</i>
        <label>{{'sidebar.expediciones.mantenimientoExpediciones.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CEX')" [routerLink]="['expediciones/mantenimiento-certificados']">
      <li routerLinkActive="active">
        <i>{{'sidebar.expediciones.mantenimientoCertificados.id' | translate}}</i>
        <label>{{'sidebar.expediciones.mantenimientoCertificados.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CET')" [routerLink]="['expediciones/trazabilidad-certificado']">
      <li routerLinkActive="active">
        <i>{{'sidebar.expediciones.trazabilidadCertificado.id' | translate}}</i>
        <label>{{'sidebar.expediciones.trazabilidadCertificado.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_THIS')"
    [ngClass]="{'current': dropdown === 'historico', 'active': url.includes('historico')}"
    (click)=" changeDropdown('historico')">
    <i class="fas fa-history"></i>
    <label>{{'sidebar.historico.des' | translate}}
      <i
        [ngClass]="dropdown === 'historico' || url.includes('historico') ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'historico' || url.includes('historico')">
    <a *ngIf="role == 'Administrador' || claims.includes('D_HCV')" [routerLink]="['historico/historico-cultivos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.historico.historicoCultivos.id' | translate}}</i>
        <label>{{'sidebar.historico.historicoCultivos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador' || claims.includes('D_HDS')" [routerLink]="['historico/historico-designaciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.historico.historicoDesignaciones.id' | translate}}</i>
        <label>{{'sidebar.historico.historicoDesignaciones.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador' || claims.includes('D_HCS')" [routerLink]="['historico/historico-consumos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.historico.historicoConsumos.id' | translate}}</i>
        <label>{{'sidebar.historico.historicoConsumos.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador'|| claims.includes('D_HET')" [routerLink]="['historico/historico-etiquetado']">
      <li routerLinkActive="active">
        <i>{{'sidebar.historico.historicoEtiquetado.id' | translate}}</i>
        <label>{{'sidebar.historico.historicoEtiquetado.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador'|| claims.includes('D_HRT')" [routerLink]="['historico/historico-reetiquetado']">
      <li routerLinkActive="active">
        <i>{{'sidebar.historico.historicoReetiquetado.id' | translate}}</i>
        <label>{{'sidebar.historico.historicoReetiquetado.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador'|| claims.includes('D_HTT')" [routerLink]="['historico/historico-totales']">
      <li routerLinkActive="active">
        <i>{{'sidebar.historico.historicoTotales.id' | translate}}</i>
        <label>{{'sidebar.historico.historicoTotales.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TROY')"
    [ngClass]="{'current': dropdown === 'royalties', 'active': (url.includes('royalties/'))}"
    (click)="changeDropdown('royalties')">
    <i class="fa-solid fa-coins"></i>
    <label>{{'sidebar.royalties.des' | translate}}
      <i
        [ngClass]="dropdown === 'royalties' || (url.includes('royalties') && !url.includes('dashboards')) ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'royalties' || (url.includes('royalties/'))">
    <a *ngIf="role === 'Administrador' || claims.includes('D_ROY')" [routerLink]="['royalties/ges-royalties']">
      <li routerLinkActive="active">
        <i>{{'sidebar.royalties.royalties.id' | translate}}</i>
        <label>{{'sidebar.royalties.royalties.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador' || claims.includes('D_COR')" [routerLink]="['royalties/mantenimiento-royalties']">
      <li routerLinkActive="active">
        <i>{{'sidebar.royalties.mantenimientoRoyalties.id' | translate}}</i>
        <label>{{'sidebar.royalties.mantenimientoRoyalties.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TADM') || claims.includes('D_LIC')"
    [ngClass]="{'current': dropdown === 'admin', 'active': url.includes('admin')}" (click)="changeDropdown('admin')">
    <i class="fas fa-university"></i>
    <label>{{'sidebar.administracion.des' | translate}}
      <i [ngClass]="dropdown === 'admin' || url.includes('admin')? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'admin' || url.includes('admin')">
    <a *ngIf="role === 'Administrador' || claims.includes('D_PSS')" [routerLink]="['admin/mantenimiento-paises']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.paises.id' | translate}}</i>
        <label>{{'sidebar.administracion.paises.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_MNC')" [routerLink]="['admin/mantenimiento-municipios']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.municipios.id' | translate}}</i>
        <label>{{'sidebar.administracion.municipios.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_MEC')" [routerLink]="['admin/mantenimiento-entidades-control']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.entidades-control.id' | translate}}</i>
        <label>{{'sidebar.administracion.entidades-control.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_LIC')" [routerLink]="['admin/ges-licencias']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.licencias.id' | translate}}</i>
        <label>{{'sidebar.administracion.licencias.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador'" [routerLink]="['admin/logs']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.logs.id' | translate}}</i>
        <label>{{'sidebar.administracion.logs.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CSV')" [routerLink]="['admin/csv-logs']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.csv-logs.id' | translate}}</i>
        <label>{{'sidebar.administracion.csv-logs.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador'" [routerLink]="['admin/registro-actividad']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.registroActividad.id' | translate}}</i>
        <label>{{'sidebar.administracion.registroActividad.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador'" [routerLink]="['admin/versiones-etiquetado']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.versionesEtiquetado.id' | translate}}</i>
        <label>{{'sidebar.administracion.versionesEtiquetado.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_CNO')" [routerLink]="['admin/central-notificaciones']">
      <li routerLinkActive="active">
        <i>{{'sidebar.administracion.centralNotificaciones.id' | translate}}</i>
        <label>{{'sidebar.administracion.centralNotificaciones.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TCFG')"
    [ngClass]="{'current': dropdown === 'configuracion', 'active': url.includes('configuracion')}"
    (click)=" changeDropdown('configuracion')">
    <i class="fas fa-cog"></i>
    <label>{{'sidebar.configuracion.des' | translate}}
      <i
        [ngClass]="dropdown === 'configuracion' || url.includes('configuracion') ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'configuracion' || url.includes('configuracion')">
    <a *ngIf="role == 'Administrador' || claims.includes('D_MET')" [routerLink]="['configuracion/mantenimiento-etiquetas']">
      <li routerLinkActive="active">
        <i>{{'sidebar.configuracion.mantenimientoEtiquetas.id' | translate}}</i>
        <label>{{'sidebar.configuracion.mantenimientoEtiquetas.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador' || claims.includes('D_DET')" [routerLink]="['configuracion/disenyo-etiquetas']">
      <li routerLinkActive="active">
        <i>{{'sidebar.configuracion.disenyoEtiquetas.id' | translate}}</i>
        <label>{{'sidebar.configuracion.disenyoEtiquetas.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role == 'Administrador' || claims.includes('D_CIC')" [routerLink]="['configuracion/configurador-consumos']">
      <li routerLinkActive="active">
        <i>{{'sidebar.configuracion.configuradorConsumos.id' | translate}}</i>
        <label>{{'sidebar.configuracion.configuradorConsumos.des' | translate}}</label>
      </li>
    </a>
  </ul>
  <li *ngIf="role === 'Administrador' || claims.includes('D_TUSR')"
    [ngClass]="{'current': dropdown === 'usuarios', 'active': url.includes('usuarios')}"
    (click)=" changeDropdown('usuarios')">
    <i class="fa fa-users"></i>
    <label>{{'sidebar.usuarios.des' | translate}}
      <i [ngClass]="dropdown === 'usuarios' || url.includes('usuarios') ? 'fas fa-angle-up' : 'fas fa-angle-down'"></i>
    </label>
  </li>
  <ul *ngIf="dropdown === 'usuarios' || url.includes('usuarios')">
    <a *ngIf="role === 'Administrador' || claims.includes('D_USR')" [routerLink]="['usuarios/usuarios']">
      <li routerLinkActive="active">
        <i>{{'sidebar.usuarios.usuarios.id' | translate}}</i>
        <label>{{'sidebar.usuarios.usuarios.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_EQS')" [routerLink]="['usuarios/etiquetadores']">
      <li routerLinkActive="active">
        <i>{{'sidebar.usuarios.etiquetadores.id' | translate}}</i>
        <label>{{'sidebar.usuarios.etiquetadores.des' | translate}}</label>
      </li>
    </a>
    <a *ngIf="role === 'Administrador' || claims.includes('D_AUD')" [routerLink]="['usuarios/auditores']">
      <li routerLinkActive="active">
        <i>{{'sidebar.usuarios.auditores.id' | translate}}</i>
        <label>{{'sidebar.usuarios.auditores.des' | translate}}</label>
      </li>
    </a>
  </ul>
</ul>
